import React from "react";
import classes from "./Pricing.css";

const pricing = () => {
    const trimestral_price = process.env.REACT_APP_TRIMESTRAL_PRICE;
    const semestral_price = process.env.REACT_APP_SEMESTRAL_PRICE;
    const anual_price = process.env.REACT_APP_ANUAL_PRICE;

    const emailSoporte = "mpalacios@set-icap.co";
    const whatsappSoporte = "3102089248";

    const subjectEmail = encodeURIComponent("Solicitud de suscripción SET-FX");
    const mensajeWhatsapp = encodeURIComponent(
        "Hola, quiero informacion sobre la suscripcion SET-FX mientras la pasarela de pagos está en mantenimiento."
    );

    return (
        <React.Fragment>
            <div className={classes.paymentmaintenancealert}>
                <h1>
                    !Actualmente nuestra pasarela de pagos se encuentra en mantenimiento¡
                </h1>

                <p>
                    Para realizar tu suscripcion o recibir asistencia, por favor comunícate
                    con nosotros a través de correo electrónico o WhatsApp.
                </p>

                <div className={classes.paymentMaintenanceActions}>
                    <a
                    href={`mailto:${emailSoporte}?subject=Solicitud de suscripción SET-FX`}
                    target= "_blank"
                    rel="noopener noreferrer"
                    className="btn btn-dark"                    
                    >
                        Contactar por correo
                    </a>
                    <a
                    href={`https://wa.me/${whatsappSoporte}?text=${mensajeWhatsapp}`}
                    target= "_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success ml-5"
                    >
                        Contactar por WhatsApp
                    </a>
                    </div> 
            </div>

            <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                    <div className="row pricing pricing-no-gutter-sm">
                        <div className="col-sm-4">
                            <div className="panel">
                                <div className="panel-body">
                                    <p className="pricing-title">Plan Trimestral</p>
                                    <p className="pricing-desc">Suscripción Dolar SET-FX</p>
                                    <div className="pricing-price">
                                        {/*<p><span className={["text-semibold text-primary", classes.PricingTitle].join(' ')}>${trimestral_price}</span></p>*/}
                                        <p><span className={["text-semibold text-primary", classes.PricingTitle].join(' ')}>$  624.047</span></p>
                                        <p>Trimestral</p>
                                    </div>
                                    <ul className="pricing-list">
                                        <li>Información en tiempo real</li>
                                        <li><strong>1</strong> Usuario</li>
                                        <li><strong>Soporte</strong> gratuito</li>
                                    </ul>
                                    <button className="btn btn-block btn-primary btn-lg btn-pay" data-plan="T">Suscribirme</button>
                                    {/* <a href="https://payco.link/248238" className="btn btn-block btn-primary btn-lg">Suscribirme</a> */}
                                   {/* <a href="https://payco.link/447619" className="btn btn-block btn-primary btn-lg">Suscribirme</a> */}
                                   {/* <div id="mydiv">
                                   </div>   */}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 pricing-featured">
                            <div className="panel">
                                <div className="ribbon"><span>POPULAR</span></div>
                                <div className="panel-body">
                                    <p className="pricing-title">Plan semestral</p>
                                    <p className="pricing-desc">Suscripción Dolar SET-FX.</p>
                                    <div className="pricing-price">
                                        {/*<p><span className={["text-semibold text-success", classes.PricingTitle].join(' ')}>${semestral_price}</span></p>*/}
                                        <p><span className={["text-semibold text-success", classes.PricingTitle].join(' ')}>$ 1.157.427</span></p>
                                        <p>Semestral</p>
                                    </div>
                                    <ul className="pricing-list">
                                        <li>Información en tiempo real</li>
                                        <li><strong>1</strong> Usuario</li>
                                        <li><strong>Soporte</strong> gratuito</li>
                                    </ul>
                                    <button className="btn btn-block btn-primary btn-lg btn-pay" data-plan="S">Suscribirme</button>
                                    {/*<a href="https://payco.link/248240" className="btn btn-block btn-primary btn-lg">Suscribirme</a>*/}
                                    {/* <div id="mydiv2">
                                    </div>  */}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="panel">
                                <div className="panel-body">
                                    <p className="pricing-title">Plan anual</p>
                                    <p className="pricing-desc">Suscripción Dolar SET-FX.</p>
                                    <div className="pricing-price">
                                        {/*<p><span className={["text-semibold text-purple", classes.PricingTitle].join(' ')}>${anual_price}</span></p>*/}
                                        <p><span className={["text-semibold text-purple", classes.PricingTitle].join(' ')}>$ 2.124.483</span></p>
                                        <p>Anual</p>
                                    </div>
                                    <ul className="pricing-list">
                                        <li>Información en tiempo real</li>
                                        <li><strong>1</strong> Usuario</li>
                                        <li><strong>Soporte</strong> gratuito</li>
                                    </ul>
                                    <button className="btn btn-block btn-primary btn-lg btn-pay" data-plan="A">Suscribirme</button>
                                    {/*<a href="https://payco.link/447845" className="btn btn-block btn-primary btn-lg">Suscribirme</a>*/}
                                    {/* <div id="mydiv3">
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </React.Fragment>
    )
}

export default pricing;
